import { featureCollection, union } from '@turf/turf';
// eslint-disable-next-line import/no-unresolved
import regionGeoJsonSource from './flanders-brussels-region.geojson?raw';

const regionGeoJson = JSON.parse(regionGeoJsonSource.replace(/^\uFEFF/, ''));

const FLANDERS_BRUSSELS_REGION_FEATURES = regionGeoJson.features;
const FLANDERS_BRUSSELS_REGION_UNION = union(
  featureCollection(FLANDERS_BRUSSELS_REGION_FEATURES),
);
const FLANDERS_BRUSSELS_REGION_EXTERIOR_RINGS = FLANDERS_BRUSSELS_REGION_UNION.geometry.type
  === 'Polygon'
  ? [FLANDERS_BRUSSELS_REGION_UNION.geometry.coordinates[0]]
  : FLANDERS_BRUSSELS_REGION_UNION.geometry.coordinates
    .map(polygonCoordinates => polygonCoordinates[0]);

export {
  FLANDERS_BRUSSELS_REGION_EXTERIOR_RINGS,
};

export default FLANDERS_BRUSSELS_REGION_FEATURES;